<template>
  <div id="app">
    <Header routeValue="-4"></Header>
    <content class="content">
      <div class="title">
        <span v-for="(item,index) in skuDesInfo.classifyNames" :key="index" @click="goDesign(item)">
          {{ item.name }}{{ index !== skuDesInfo.classifyNames.length - 1 ? ' / ' : '' }}
        </span>
      </div>
      <div class="content_box">
        <div class="content_l">

          <a-carousel arrows dots-class="slick-dots slick-thumb" ref="carousel">

            <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;z-index: 1">
              <a-icon type="left-circle"/>
            </div>
            <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
              <a-icon type="right-circle"/>
            </div>

            <a slot="customPaging" slot-scope="props">
              <img :src="getImgUrl(props.i)"/>
            </a>
            <div v-for="item in skuDesInfo.defaultVariantVO.skuVO.skuProductImgVOS">
              <div class="img_box">
                <img :src="item.imgUrl| imgFilter(764)" alt="image"/>
              </div>
            </div>
          </a-carousel>
        </div>
        <div class="content_r">
          <span class="name" v-wechat-title="getWechatTitle()">{{
              skuDesInfo.defaultVariantVO.skuVO.skuTitle || 'N/A'
            }}</span>
          <div class="product_box">
            <div class="productField-wrap">
              <article class="productField productField--dropdown" :class="{ '_is-on': isOpen }"
                       data-product-dropdown="field"
                       data-product-field="Department" :data-current="selectedName">
                <div class="productField-title productField-title--dropdown" :class="{ '_is-on': isOpen }"
                     data-product-dropdown="trigger" @click="toggleDropdown()">
                  {{ isOpen ? 'Product' : selectedName || 'Product' }}
                </div>
                <ul class="productField-list productField-list--dropdown" :class="{ '_is-on': isOpen }"
                    data-product-dropdown="target" v-if="isOpen">
                  <li class="productField-dropdown" v-for="item in skuDesInfo.productVO">
                    <a @click.prevent="selectDepartment(item,item.variantVOS[0].id)"
                       class="pjax-link dept-link">{{ item.productName }}</a>
                  </li>
                </ul>
                <svg class="productField-dropdown-icon" data-dropdown-arrow="" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                     width="18px" height="9px" viewBox="0 0 18 9" version="1.1"
                     v-if="skuDesInfo.productVO.length>1">
                  <g id="Theme-1" stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">
                    <g id="PDP:-Top-Nav-Copy" sketch:type="MSArtboardGroup"
                       transform="translate(-1083.000000, -326.000000)">
                      <g id="Product-Info" sketch:type="MSLayerGroup" transform="translate(836.000000, 201.000000)">
                        <path d="M250,119 L256,125 L262,131 L250,131 L250,119 Z" id="Rectangle-105-Copy"
                              sketch:type="MSShapeGroup"
                              transform="translate(256.000000, 125.000000) rotate(-45.000000) translate(-256.000000, -125.000000) "></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </article>
            </div>
            <div class="designs_box" ref="designsBox">
              <div>
                <div v-for="(productItem, productIndex) in specifications">
                  <div class="subhead">{{ productItem.name }}</div>
                  <div class="designs_list">
                    <div v-for="(oItem, oIndex) in productItem.item" :key="oItem.name"
                         :class="{ noneActive: !oItem.checked, active: subIndex[productIndex] === oIndex }"
                         @click="selectArrayBtn(oItem, productIndex, oIndex)" class="designs-item">
                      {{ oItem.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="des_box">
                <span v-html="skuDesInfo.defaultVariantVO.skuVO.content"></span>
              </div>
              <a-button type="primary" class="btm" @click="toWhatsApp" v-if="skuDesInfo.productVO.length>0">
                Contact us
              </a-button>
              <div class="link_box" v-if="skuDesInfo.productVO.length>0">
                <div v-for="item in linkList" class="item" @mouseover="applyColorFilter(item)"
                     @mouseleave="removeColorFilter(item)">
                  <a :href="getHref(item)" :title="item.title" target="_blank" @click="shareToFacebook($event,item)">
                    <img
                      style="width: 27px;height: 27px"
                      :src="item.image"
                      alt="image"
                      :style="{ filter: item.colorFilter }">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_btm" :style="{marginTop:dynamicHeight }">
        <div class="shop">Shop more designs</div>
        <a-carousel arrows :dots="false" autoplay :autoplay-speed="5000">
          <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: -5px;z-index: 1">
            <a-icon type="left"/>
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 3px;z-index: 1">
            <a-icon type="right"/>
          </div>
          <div v-for="(obj,key) in rightDisplay" :key="key">
            <div v-for="(obj2,key) in obj.imgs" :key="key" class="hotBox" @click="handleSelectRecommend(obj2)">
              <div class="img_box">
                <img :src="obj2.materialImgList[0].imgUrl| imgFilter(250)"/>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {getVariantDataById, isIdEmpty, setDataToSpecs, setDifferenceArray} from '../utils/utils.js'

export default {
  name: 'Details',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      id: undefined,
      isOpen: false,
      title: '',
      selectedName: '',
      dynamicHeight: 0,
      specifications: [],
      //存放要和选中的值进行匹配的数据
      shopItemInfo: {},
      //存放被选中的值
      selectArr: [],
      //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      subIndex: [],
      //最终匹配到的数据（id/名称）
      boxArr: {},
      imgUrl: '',
      skuDesInfo: {
        classifyNames: [],
        productVO: [],
        defaultVariantVO: {
          skuVO: {}
        },

      },
      linkList: [
        {
          type: 1,
          title: 'Pinterest',
          link: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`,
          image: require('@/assets/p@2x.png'),
          colorFilter: 'grayscale(20%)'
        },
        {
          type: 2,
          title: 'Tumblr',
          link: `https://www.tumblr.com/share?content=${encodeURIComponent(window.location.href)}`,
          image: require('@/assets/t@2x.png'),
          colorFilter: 'grayscale(20%)'
        },
        {
          type: 3,
          title: 'Twitter',
          link: `http://twitter.com/intent/tweet?text=${encodeURIComponent(window.location.href)}`,
          image: require('@/assets/fs@2x.png'),
          colorFilter: 'grayscale(20%)'
        },
        {
          type: 4,
          title: 'Email',
          link: `mailto:?subject=Check out this Oasisdream design, Souper Duper Bowl of Soup!&amp;body=I thought you'd like this design:${encodeURIComponent(window.location.href)}`,
          image: require('@/assets/e@2x.png'),
          colorFilter: 'grayscale(20%)'
        },
        {
          type: 5,
          title: 'Facebook',
          link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`,
          image: require('@/assets/f@2x.png'),
          colorFilter: 'grayscale(20%)'
        }
      ],
      rightDisplay: [],
    }
  },
  computed: {},
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href
    this.goToSlide(1, true)
  },
  updated () {
    this.$nextTick(() => {
      let height = this.$refs.designsBox.offsetHeight
      this.dynamicHeight = (height - 632) + 'px'
    })
  },
  created () {
    this.id = this.$route.params.id || undefined
    this.getMaterialSkuDes()
    this.getRecommendList()

  },
  methods: {
    goToSlide (slideNumber) {
      this.$refs.carousel.goTo(slideNumber, true)
    },
    getMaterialSkuDes () {
      this.$http({method: 'get', url: `/api/material/sku/detail/${this.id}`}).then((res) => {
        if (res.data.code === 0) {
          this.skuDesInfo = res.data.data
          this.imgUrl = this.skuDesInfo.defaultVariantVO.skuVO.skuProductImgVOS[0].imgUrl
          const productVO = getVariantDataById(this.skuDesInfo.productVO, this.skuDesInfo.defaultProductId)
          this.selectDepartment(productVO, this.skuDesInfo.defaultVariantVO.id)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getImgSkuVariant (skuVariantId) {
      this.$http({method: 'get', url: `/api/material/variant/img/${skuVariantId}`}).then((res) => {
        if (res.data.code === 0) {
          let obj = res.data.data
          obj.skuVO.skuProductImgVOS.unshift({id: '', imgUrl: this.skuDesInfo.materialImgUrl})
          this.skuDesInfo.defaultVariantVO = obj
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.carousel.goTo(1, false) // 使用 false 禁用动画效果
            }, 600)
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getRecommendList () {
      this.$http({method: 'get', url: `/api/material/recommend`}).then((res) => {
        if (res.data.code === 0) {
          const rightDisplay = res.data.rows.reduce((acc, item, index) => {
            const groupIndex = Math.floor(index / 6)
            if (!acc[groupIndex]) {
              acc[groupIndex] = {imgs: []}
            }
            acc[groupIndex].imgs.push(item)
            return acc
          }, [])
          rightDisplay.reverse()
          this.rightDisplay = rightDisplay
        } else {
          this.$message.error(res.data.msg)
        }

      })
    },
    toggleDropdown () {
      if (this.skuDesInfo.productVO.length <= 1) return
      this.isOpen = !this.isOpen
    },
    //接口初始化、选择产品
    selectDepartment (item, selectedVid) {
      this.selectArr = []
      this.selectedName = item.productName
      this.isOpen = false
      const attrList = setDataToSpecs(item.variantVOS)
      const differenceList = setDifferenceArray(this.skuDesInfo.productVO)
      differenceList.forEach(item => {
        this.$set(this.shopItemInfo, item.difference, item)
      })
      attrList.forEach(attr => {
        attr.item.forEach(item => {
          this.$set(item, 'checked', true)
        })
      })
      this.specifications = [...attrList]
      this.initSelectedById(differenceList, selectedVid)
    },

    goDesign (item) {
      this.$router.push({name: 'Design', params: {id: item.id}})
    },
    getWechatTitle () {
      if (this.skuDesInfo.defaultVariantVO.skuVO.skuTitle) {
        return this.skuDesInfo.defaultVariantVO.skuVO.skuTitle + ' | Oasisdream'
      } else {
        return 'Designs | Oasisdream'
      }
    },
    shareToFacebook (event, item) {
      if (item.type !== 4) {
        event.preventDefault()
        const screenWidth = window.screen.width
        const screenHeight = window.screen.height
        const width = 516
        const height = 573
        const left = Math.round((screenWidth - width) / 2)
        const top = Math.round((screenHeight - height) / 2)
        window.open(item.link, 'facebook-share-dialog', `left=${left},top=${top},width=${width},height=${height}`) // 打开分享对话框
      }
    },
    getHref (item) {
      if (item.type === 1) {
        return item.link + `&media=${encodeURIComponent(this.imgUrl)}`
      } else {
        return item.link
      }
    },
    getImgUrl (i) {
      let url = this.skuDesInfo.defaultVariantVO.skuVO.skuProductImgVOS[i].imgUrl
      return this.$options.filters['imgFilter'](url, 68)
    },
    handleSelectRecommend (row) {
      const url = window.location.href
      // const regex = /(\?|&)id=\d+/ // 匹配 id 参数的正则表达式
      // const newUrl = url.replace(regex, `$1id=${row.id}`)
      const regex = /\/(\d+)$/
      const newUrl = url.replace(regex, '/' + row.id)
      // 刷新页面
      window.location.href = newUrl
    },
    applyColorFilter (item) {
      item.colorFilter = ''
    },
    removeColorFilter (item) {
      item.colorFilter = 'grayscale(20%)'
    },
    toWhatsApp () {
      const phoneNumber = '+8613105926618'
      const baseUrl = 'https://api.whatsapp.com/send'
      const phone = encodeURIComponent(phoneNumber)
      window.open(`${baseUrl}?phone=${phone}`, '_blank')
    },
    /**
     * 根据默认id初始化选中状态
     * @param list
     * @param selectedId
     */
    initSelectedById (list, selectedId) {
      const selectedItem = list.find(item => parseInt(item.id) === parseInt(selectedId))
      if (selectedItem) {
        const selectedAttributes = selectedItem.difference.split(',')
        selectedAttributes.forEach((attr, index) => {
          const attrItem = this.specifications[index].item.find(item => item.name === attr)
          if (attrItem) {
            attrItem.checked = true
            this.selectArrayBtn(attrItem, index, this.specifications[index].item.indexOf(attrItem))
          }
        })
      }
    },
    selectArrayBtn (item, index, arrayIndex) {
      this.$forceUpdate()
      if (this.selectArr[index] !== item.name) {
        this.selectArr[index] = item.name
        this.subIndex[index] = arrayIndex
      } else {
        return
        // this.selectArr[index] = ''
        // this.subIndex[index] = -1
      }
      this.checkItem()
      const selectObj = this.shopItemInfo[this.selectArr.join(',')]
      if (selectObj) {
        this.boxArr = {id: selectObj.id, difference: selectObj.difference}
      } else {
        this.boxArr = {}
      }
      if (!isIdEmpty(this.boxArr)) {
        this.getImgSkuVariant(this.boxArr.id)
      }
    },
    checkItem () {
      const array = this.specifications
      let result = []
      for (let i in array) {
        result[i] = this.selectArr[i] ? this.selectArr[i] : ''
      }

      for (let i in array) {
        let last = result[i]
        for (let k in array[i].item) {
          result[i] = array[i].item[k].name
          array[i].item[k].checked = this.isMay(result)
        }
        result[i] = last
      }
      this.specifications = array
    },
    isMay (result) {
      for (let i in result) {
        if (result[i] == '') return true
      }
      const selectedValue = this.shopItemInfo[result.join(',')]
      return selectedValue ? true : false
    }
  },
}
</script>
<style scoped lang="less">


.content {
  margin: 40px 162px 0 160px;
  min-height: 471px;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 28px;
    color: #4C8EFF;
  }


  .content_box {
    display: flex;
    flex-direction: row;

    .content_l {
      width: 764px;
      display: flex;
      height: 839px;
      position: relative;
      flex-direction: column;


      .ant-carousel .custom-slick-arrow {
        width: 35px;
        height: 35px;
        font-size: 35px;
        color: #E8E8E8;
        opacity: 0.3;
      }

      .ant-carousel .custom-slick-arrow:before {
        display: none;
      }

      .ant-carousel .custom-slick-arrow:hover {
        opacity: 0.5;
      }

      /deep/ .ant-carousel .slick-dots {
        width: 764px;
        height: auto;
        text-align: left;
        overflow-x: auto;
        white-space: nowrap;
      }

      /deep/ .ant-carousel {
        border: 1px solid #fff;
        height: 764px;
        width: 764px;
      }

      /deep/ .ant-carousel .slick-slide .img_box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
      }

      /deep/ .ant-carousel .slick-slide .img_box img {
        width: 100%;
        height: 100%;
        color: #4C8EFF;
        object-fit: contain;
      }

      /deep/ .ant-carousel .slick-thumb {
        bottom: -80px;
      }

      /deep/ .ant-carousel .slick-thumb li {
        width: 68px;
        height: 68px;
      }

      /deep/ .ant-carousel .slick-thumb li img {
        width: 100%;
        height: 100%;
        border: 1px solid transparent;
      }

      /deep/ .ant-carousel .slick-thumb li.slick-active img {
        filter: grayscale(0%);
        border: 1px solid #4C8EFF;
      }

      /deep/ .ant-carousel .slick-slide {
        text-align: center;
        height: 764px;
        line-height: 764px;
        overflow: hidden;
      }

    }

    .content_r {
      width: 812px;
      margin-left: 30px;


      .name {
        font-weight: bold;
        font-size: 24px;
        color: #4C8EFF;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }


      .product_box {
        margin-top: 39px;
        position: relative;

        .productField-wrap {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          column-gap: 0.6em;

          .productField {
            clear: both;
            width: 380px;
            position: relative;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-transform: translate3d(0, 0, 0);
          }

          .productField--dropdown._is-on {
            z-index: 200;
          }

          li {
            display: list-item;
            font-size: 18px;
            text-align: -webkit-match-parent;
          }

          ul {
            list-style: none;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 0;
          }

          .productField-title {
            cursor: pointer;
          }

          .productField-title--dropdown._is-on {
            border-bottom: 0;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            position: relative;
            z-index: 4;
          }

          .productField-title--dropdown {
            border-color: #4c8eff;
            background: #141414;
          }

          .productField-title--dropdown {
            border-radius: 5px;
            border-width: 1px;
            border-style: solid;
            padding: 0 0 0 1em;
            font-size: 18px;
            line-height: 48px;
            height: 48px;
          }

          .productField-list--dropdown._is-on {
            height: auto;
            margin: 0;
            clip: auto;
            overflow: visible;
            z-index: 4;
            border-width: 1px;
            border-style: solid;
            border-top: 0;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
          }

          .productField-list--dropdown {
            border-color: #4c8eff;
            background: #141414;
            color: #4c8eff;
          }

          .productField-list {
            display: inline-block;
            width: 100%;
          }

          .productField-dropdown {
            padding: 0.5em 0;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
          }

          .productField-dropdown a, .productField-dropdown a:hover {
            color: inherit;
            text-decoration: none;
          }

          .productField-dropdown a {
            display: block;
            vertical-align: middle;
            line-height: 1.8;
            padding: 0 0 0 1em;
          }

          .productField-dropdown:hover {
            background: #4c8eff;
            color: #ffffff;
          }

          .productField-dropdown:hover {
            -webkit-transition: all 100ms linear;
            -moz-transition: all 100ms linear;
            -ms-input-transition: all 100ms linear;
            -o-transition: all 100ms linear;
            transition: all 100ms linear;
          }

          .productField-dropdown {
            padding: 0.5em 0;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
          }

          .productField-title--dropdown._is-on ~ .productField-dropdown-icon {
            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -ms-input-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
          }

          svg:not(:root) {
            overflow: hidden;
          }

          .productField-dropdown-icon {
            fill: #4c8eff;
          }

          .catalogDropdown-icon, .productField-dropdown-icon {
            height: 5px;
            width: 11px;
            right: 1em;
            position: absolute;
            top: 23px;
            z-index: 5;
            -webkit-transition: -webkit-transform .2s ease-in;
            -moz-transition: -moz-transform .2s ease-in;
            -ms-input-transition: -ms-input-transform .2s ease-in;
            -o-transition: -o-transform .2s ease-in;
            transition: transform .2s ease-in;
          }

        }

        .designs_box {
          width: 100%;
          display: flex;
          min-height: 700px;
          flex-direction: column;
          position: absolute;
          top: 70px;


          .subhead {
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 15px;
            color: #4C8EFF;
          }

          .designs_list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 10px;

            .designs-item {
              min-width: 83px;
              padding: 0 5px;
              height: 48px;
              line-height: 48px;
              background-color: #141414;
              border-radius: 6px;
              cursor: pointer;
              border: 1px solid #4C8EFF;
              margin-right: 12px;
              margin-bottom: 10px;
              font-weight: bold;
              font-size: 16px;
              text-align: center;
              color: #4C8EFF;
            }

            .noneActive {
              background-color: #ccc;
              border: 1px solid #ccc;
              opacity: 0.4;
              color: #fff;
              pointer-events: none;
            }

            .active {
              background-color: #4C8EFF;
              color: #fff;
              border: 1px solid #4C8EFF;
            }

          }

          .des_box {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
          }

          .btm {
            width: 100%;
            height: 53px;
            font-size: 23px;
            font-weight: bold;
            margin-top: 50px
          }
        }

        .link_box {
          justify-content: right;
          display: flex;
          margin-top: 27px;

          .item {
            margin-left: 11px;
          }
        }
      }

    }

  }

  .content_btm {
    margin-top: 68px;
    margin-bottom: 50px;

    .shop {
      font-weight: bold;
      font-size: 22px;
      color: #4C8EFF;
      margin-bottom: 28px;
    }
  }

  .content_btm .ant-carousel .slick-slide {
    width: 251px;
    height: 251px;
    overflow: hidden;
    background: #fff;
  }

  .content_btm .ant-carousel .slick-slide .hotBox {
    width: 251px;
    float: left;
    pointer-events: auto;
    margin-right: 16px;
  }

  .content_btm .ant-carousel .slick-slide .hotBox:last-child {
    margin-right: 0;
  }


  .content_btm .ant-carousel .slick-slide .hotBox .img_box {
    width: 251px;
    height: 251px;
    display: flex;
    border: 1px solid #FFFFFF;
    justify-content: center;
    align-items: center;
  }

  .content_btm .ant-carousel .slick-slide .hotBox .img_box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .content_btm .ant-carousel .custom-slick-arrow {
    width: 42px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #ff5932;
    background-color: rgba(255, 255, 255, 0.5);
    margin: auto;
    position: absolute;
    top: calc(50%);
    transform: translateY(-50%);
    z-index: 50;
  }

  .content_btm .ant-carousel .custom-slick-arrow:before {
    display: none;
  }

  .content_btm .ant-carousel .custom-slick-arrow:hover {
    opacity: 0.9;
    color: #ffffff;
    background-color: #ff5932;
  }


}
</style>



// WEBPACK FOOTER //
// src/views/Details3.vue